import { ContextAction } from '../types';
import type {
  CoBrandDetailsAction,
  CoBrandDetailsState,
  OptionVisibilityState
} from './types';

export const optionVisibilityInitial: OptionVisibilityState = {
  hiddenOptions: [],
  isLoaded: false
};

export const coBrandDetailsInitial: CoBrandDetailsState = {
  name: '',
  logo: '',
  smallLogo: '',
  lang: '',
  subDomain: '',
  clientId: '',
  themeName: 'primary',
  carousal: [],
  isLoaded: false,
  excludedAncillarySources: [],
  optionVisibility: optionVisibilityInitial
};

export const coBrandDetailsReducer = (
  state: CoBrandDetailsState = coBrandDetailsInitial,
  action: CoBrandDetailsAction
): CoBrandDetailsState => {
  switch (action.type) {
    case ContextAction.setCoBrandDetails:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
